module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-wrap margin-bottom-0",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "widget-header block-header margin-bottom-0 clearfix"
  }, [_c('div', [_c('h3', [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("歷史紀錄")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right form-group",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('a', {
    staticClass: "btn btn-default pointer",
    class: {
      active: _vm.select == 'note'
    },
    on: {
      "click": function($event) {
        _vm.select = 'note'
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-comments"
  }), _vm._v(" 留言(" + _vm._s(_vm.countActivities('note')) + ")\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default pointer",
    class: {
      active: _vm.select == 'event'
    },
    on: {
      "click": function($event) {
        _vm.select = 'event'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" 待辦事項(" + _vm._s(_vm.countActivities('event')) + ")\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default pointer",
    class: {
      active: _vm.select == 'attachment'
    },
    on: {
      "click": function($event) {
        _vm.select = 'attachment'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" 檔案(" + _vm._s(_vm.countActivities('attachment')) + ")\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default pointer",
    class: {
      active: _vm.select == 'stage'
    },
    on: {
      "click": function($event) {
        _vm.select = 'stage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock"
  }), _vm._v(" 交易狀態(" + _vm._s(_vm.countActivities('stage')) + ")\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default pointer",
    class: {
      active: _vm.select == 'all'
    },
    on: {
      "click": function($event) {
        _vm.select = 'all'
      }
    }
  }, [_vm._v("\n              全部(" + _vm._s(_vm.activities.length) + ")\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "widget-container history-box margin-top-0"
  }, [_c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "activities-container"
  }, [_c('ul', {
    staticClass: "text-left history-line"
  }, [(_vm.filterActivities.length == 0) ? _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [(_vm.select == 'all') ? _c('p', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_vm._v("無任何歷史紀錄"), _c('br'), _c('br'), _vm._v("可透過『新增留言』，『新增待辦事項』，『上傳檔案』等按鈕留下案件紀錄。")]) : _vm._e(), _vm._v(" "), (_vm.select == 'note') ? _c('span', [_vm._v("無留言")]) : _vm._e(), _vm._v(" "), (_vm.select == 'event') ? _c('span', [_vm._v("無沒有待辦事項")]) : _vm._e(), _vm._v(" "), (_vm.select == 'attachment') ? _c('span', [_vm._v("無沒有檔案")]) : _vm._e(), _vm._v(" "), (_vm.select == 'stage') ? _c('span', [_vm._v("無交易狀態變化")]) : _vm._e()])]) : _vm._l((_vm.filterActivities), function(activity) {
    return _c('div', {
      staticClass: "activities-list"
    }, [(activity.content_type == 'stage' || activity.content_type == 'add_contact') ? _c('li', [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "activities-details"
    }, [_c('h3', {
      staticClass: "activities-header"
    }, [_vm._v("交易狀態： " + _vm._s(activity.content))]), _vm._v(" "), _c('div', {
      staticClass: "activities-meta"
    }, [_c('i', {
      staticClass: "fa fa-clock-o "
    }), _vm._v(" " + _vm._s(_vm._f("moment")(activity.created_at, "YYYY/MM/DD a h:mm:ss ")) + "\n                  "), _c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(_vm._s(activity.user_name) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (activity.content_type == 'event') ? _c('li', [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "activities-details"
    }, [_c('div', {
      staticClass: "pull-right history-edit-box"
    }, [(activity.activity_status == 'doing') ? _c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          activity.activity_status = 'finish';
          _vm.updateActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check text-gray"
    })]) : _c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          activity.activity_status = 'doing';
          _vm.updateActivity(activity)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-check-circle text-gray text-success"
    })])]), _vm._v(" "), _c('h3', {
      staticClass: "activities-header"
    }, [_vm._v("待辦事項：\n                  "), _c('span', {
      staticClass: "activities-meta"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm.showActivityTime(activity)) + "\n                    "), _c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(activity.user_name) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "activities-post"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.getActivityCategory(activity))
      }
    }), _vm._v(" "), (activity.location != '') ? _c('p', [_c('i', {
      staticClass: "fas fa-map-marker"
    }), _vm._v(" " + _vm._s(activity.location))]) : _vm._e(), _vm._v(" "), (activity.content.length > 0) ? _c('pre', [_vm._v(_vm._s(activity.content))]) : _vm._e()])])]) : (activity.content_type == 'attachment') ? _c('li', [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "activities-details"
    }, [_c('h3', {
      staticClass: "activities-header"
    }, [_vm._v("上傳檔案：\n                  "), _c('span', {
      staticClass: "activities-meta"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(_vm._s(_vm._f("moment")(activity.created_at, "YYYY/MM/DD a h:mm:ss ")) + "\n                    "), _c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(_vm._s(activity.user_name) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "activities-post"
    }, [_c('ul', {
      staticClass: "new-comments-lists"
    }, [_c('li', {
      staticClass: "log_content"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": activity.attachment.url
      }
    }, [_vm._v(_vm._s(activity.title || activity.attachment.file_name))])])])])])]) : (activity.content_type == 'note') ? _c('li', [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "activities-details"
    }, [(activity.edit != activity.content) ? _c('div', {
      staticClass: "pull-right history-edit-box"
    }, [_c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          activity.edit = activity.content;
          _vm.content_cache = activity.content
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "row-edit",
      on: {
        "click": function($event) {
          _vm.deleteActivity(activity)
        }
      }
    }, [_c('span', {
      staticClass: "zmdi zmdi-close"
    })])]) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "activities-header"
    }, [_vm._v("留言\n                  "), _c('span', {
      staticClass: "activities-meta"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(_vm._s(_vm._f("moment")(activity.created_at, "YYYY/MM/DD a h:mm:ss ")) + "\n                    "), _c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(_vm._s(activity.user_name) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "activities-post"
    }, [_c('ul', {
      staticClass: "new-comments-lists"
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (activity.edit == 'no' || activity.edit != activity.content),
        expression: "activity.edit=='no' || activity.edit!=activity.content"
      }],
      staticClass: "log_content"
    }, [_vm._v(_vm._s(activity.content))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (activity.edit == activity.content),
        expression: "activity.edit==activity.content"
      }],
      staticClass: "j-forms"
    }, [_c('div', {
      staticClass: "form-content"
    }, [_c('div', {
      staticClass: "unit"
    }, [_c('div', {
      staticClass: "input"
    }, [_c('label', {
      attrs: {
        "for": "textarea"
      }
    }), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.content_cache),
        expression: "content_cache"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "新增註記內容"
      },
      domProps: {
        "value": (_vm.content_cache)
      },
      on: {
        "keydown": function($event) {
          _vm.content_type = 'note'
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.content_cache = $event.target.value
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-footer"
    }, [_c('button', {
      staticClass: "btn btn-info primary-btn",
      on: {
        "click": function($event) {
          activity.edit = 'no'
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info primary-btn",
      on: {
        "click": function($event) {
          activity.edit = 'no';
          activity.content = _vm.content_cache;
          _vm.updateActivity(activity)
        }
      }
    }, [_vm._v("更新")])])])])])])]) : _vm._e()])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities-badge"
  }, [_c('span', {
    staticClass: "w_bg_amber"
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities-badge"
  }, [_c('span', {
    staticClass: "w_bg_red"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities-badge"
  }, [_c('span', {
    staticClass: "w_bg_deep_purple"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities-badge"
  }, [_c('span', {
    staticClass: "w_bg_teal"
  }, [_c('i', {
    staticClass: "zmdi zmdi-comments"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ffd4b9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/History.vue
// module id = 667
// module chunks = 4